module.exports = __webpack_public_path__ + "img/v-line-md.50d30eca.svg";